let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kTsGE")).then(() => parcelRequire('dwA0d'));